import { environmentHttpClient as httpClient } from "client/Api/httpClient";
import { UsersAndUserGroupsDataModel } from "../UserGroupsManagement/userGroupsManagement";
import { PermissionsUnionModel } from "../common";

export type SettingsViewModel = {
	whoHasAccess: PermissionsUnionModel;
};

export type SettingsSaveModel = {
	whoHasAccess: PermissionsUnionModel;
};

export type AiAssistantSettingsPageModel = {
	isProvisioned: boolean;
	kellyHelpsUrl: string;
	settings: OptionalModel<SettingsViewModel>;
	usersAndUserGroupsData: UsersAndUserGroupsDataModel;
};

export type AiAssistantSettingsSaveModel = {
	settings: OptionalModel<SettingsSaveModel>;
};

export type FreeCreditsModel = {
	total: number;
	used: number;
};

export type AiAssistantUsageModel = {
	freeCredits: FreeCreditsModel;
	extraCredits: number;
};

export enum ProvisionKellyTenantPrerequisite {
	PrimaryEmailAddress = 0
}

export type ProvisionKellyTenantModel = {
	hasAcceptedTerms: boolean;
};

export function getAiAssistantSettings(signal: AbortSignal): Promise<AiAssistantSettingsPageModel> {
	return httpClient.get<AiAssistantSettingsPageModel>(
		"UiApi/AIAssistantSettings",
		undefined,
		{ signal }
	);
}

export function saveAiAssistantSettings(
	model: AiAssistantSettingsSaveModel,
	signal: AbortSignal
): Promise<void> {
	return httpClient.put<void>(
		"UiApi/AIAssistantSettings",
		model,
		{ signal }
	);
}

export function getAiAssistantUsage(signal: AbortSignal): Promise<AiAssistantUsageModel> {
	return httpClient.get<AiAssistantUsageModel>(
		"UiApi/AIAssistantSettings/Usage",
		undefined,
		{ signal }
	);
}

export function provisionKellyTenant(
	model: ProvisionKellyTenantModel,
	signal: AbortSignal
): Promise<void> {
	return httpClient.post<void>(
		"UiApi/AIAssistantSettings/Provision",
		model,
		{ signal }
	);
}
